import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { updateRecordingForPath } from '../../utils/posthog'

// STY-445: react-router-dom 5.0.1 predates the location hooks, so this withRouter component
// subscribes to history changes and starts/stops session replay as the user enters/leaves a
// recording path (/submissions/submission/*). The initial path is also covered by PostHog's
// `loaded` callback in initPostHog; updateRecordingForPath is a safe no-op until the SDK loads and
// never records in a cookieless (EU/GPC) mode. Renders nothing.
class SessionRecordingManager extends Component {
  componentDidMount () {
    updateRecordingForPath(this.props.location.pathname)
    this.unlisten = this.props.history.listen((location) => {
      updateRecordingForPath(location.pathname)
    })
  }

  componentWillUnmount () {
    if (this.unlisten) this.unlisten()
  }

  render () {
    return null
  }
}

export default withRouter(SessionRecordingManager)
